module.exports = __webpack_public_path__ + "img/dna_w.c91749fd.svg";